import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { QBuiltConstants } from 'src/app/modules/qbuilt/models/constants/qbuilt.constants';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { Observable } from 'rxjs';
import { CanDeactivateWithUnsavedChanges } from 'src/app/shared/guards/unsaved-changes.guard';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { DrawerService } from 'src/app/shared/services/drawer.service';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
    selector: 'qbuilt-navbar',
    imports: [
      MatIconModule,
      MatMenuModule
    ],
    templateUrl: './qbuilt-navbar.component.html',
    styleUrl: './qbuilt-navbar.component.scss'
})
export class QbuiltNavbarComponent implements CanDeactivateWithUnsavedChanges {
  @Input() isHomePage: boolean;
  icons = {
    account: 'account_circle',
    theme: 'light_mode',
  };

  capturedChanges: boolean = false;

  cqmsSessionKey: string = this.qbuiltInspectorConstants.cqmsItemsKey;

  constructor(
    private router: Router, 
    private dialogService: DialogService,
    private qbuiltConstants: QBuiltConstants,
    private qbuiltInspectorConstants: QBuiltInspectorConstants,
    public settingsDrawer: DrawerService,
    private themeService: ThemeService
  ) {}

  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;

  //toggles light or dark mode for the user
  toggleSettings(heading: string) {
    this.settingsDrawer.heading = heading;
    this.settingsDrawer.state.update((value: boolean) => (value = !value));
  }

  // Implementation for CanComponentDeactivate interface
  hasUnsavedChanges(): boolean {
    return this.capturedChanges === true ? true : false;
  }

  getSaveChangesDialogConfig() {
    return {
      title: this.qbuiltConstants.dialogTitle,
      message: this.qbuiltConstants.dialogMessage,
      cancelButtonText: this.qbuiltConstants.cancelButtonText,
      confirmButtonText: this.qbuiltConstants.confirmButtonText
    };
  }

  goToHomePage() {
    this.capturedChanges = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').capturedChanges || false;
    if(this.capturedChanges === true) {
      this.saveChangesDialog();
    } else if (this.capturedChanges === false) {
      this.navigateToHome();
    }
  }

  setNavLogo() {
    return this.themeService.currentTheme === 'light'
      ? 'assets/logos/QBuilt_logoBlk.png'
      : 'assets/logos/QBuilt_logoPurple.png';
  }

  navigateToHome() {
    sessionStorage.clear();
    //clean out previous inspection data that should be reloaded 
    sessionStorage.removeItem(this.cqmsSessionKey);
    sessionStorage.removeItem(this.qbuiltInspectorConstants.defectItemsKey);
    sessionStorage.removeItem('saveProgressDisabled');
    this.router.navigate(['/cqms-home']);

  }

  //Calls dialog if there are unsaved changes
  saveChangesDialog() {
    const dialogRef = this.dialogService.openDialog(
      this.qbuiltConstants.dialogTitle,
      this.qbuiltInspectorConstants.saveProgressMessage,
      this.qbuiltConstants.cancelButtonText,
      this.qbuiltConstants.confirmButtonText,
      true
    );
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.navigateToHome();
      }
    });
  }
}